import BasePaytableContainer from "../paytable/BasePaytableContainer";
import EntryPoint from "Engine/EntryPoint";

export default class BaseMobilePaytableLandscapeContainer extends BasePaytableContainer {
    constructor(data, displayItemData) {
        super(data, displayItemData);
    }

    init() {
        super.init();
        this.maskContainer = this.getChildAt(3);
    }

    addScrollListeners() {
        this.scrollableContainer.on('touchstart', this.onTouchStart, this);
        this.scrollableContainer.on('touchmove', this.onTouchMove, this);
        this.scrollableContainer.on('touchend', this.onTouchEnd, this);
        this.scrollableContainer.on('touchcancel', this.onTouchEnd, this);
    }

    onTouchStart(event) {
        let position = event.data.getLocalPosition(this.scrollableContainer);
        this.lastPosition = position;

    }

    onTouchMove(event) {
        if (!this.lastPosition) {
            return;
        }
        let position = event.data.getLocalPosition(this.scrollableContainer);
        this.scrollableContainer.emit('scroll', { wheelDelta: position.y - this.lastPosition.y });
        this.lastPosition = position;
    }

    onTouchEnd(event) {
        this.lastPosition = null;
    }

    resize(data) {
        if (data.height) {
            this.background.height = data.height;
            this.scrollableContainer.height = data.height - 110 - 2;
            this.maskContainer.height = data.height - 110 - 2;

            this.background.y = this.background.height / 2;
            this.scrollableContainer.y = this.scrollableContainer.height / 2 + 110;
            this.maskContainer.y = this.maskContainer.height / 2 + 110;
        }

        if (data.width) {
            this.background.width = data.width;
            this.scrollableContainer.width = data.width;
            this.maskContainer.width = data.width;

            this.container.width = Math.min(this.container.width, data.width - 20);
            this.container.scale.y = this.container.scale.x;
        }

        this.initMaskParams();

        if (this.scrollBar) {
            this.baseY = this.maskContainer.y - this.maskContainer.height / 2;
            this.maskHeight = this.maskContainer.height;

            this.scrollBar.setData({contentHeight: this.container.height, containerHeight: this.maskHeight});

            let totalValue = Math.abs(this.container.height - this.maskHeight);
            let value = Math.abs(this.container.y - this.baseY);
            let currentValue = value / totalValue;

            this.scrollBar.value = currentValue * 100;

            this.scrollBar.x = (this.background.width / 2 - this.scrollBar.width) - 18;
        }
    }

    getContainer() {
        this.container = this.getChildByName('container');

        this.container.width = Math.min(this.container.width, this.background.width - 50);
        this.container.scale.y = this.container.scale.x;

        super.getContainer();
        if (this.scrollBar) {
            this.scrollBar.x = (this.background.width / 2 - this.scrollBar.width) - 18;
        }
    }
}